module.exports = __webpack_public_path__ + "dash_20_app_assets/img/fb.5a33fd3a.png";